/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
// import { useDispatch } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';
import { TaskInputs } from '../TaskInputs/TaskInputs';
import { InputConfig } from '../TaskInputs/types';
// import { participantAPI } from '../../../api/participant';
// import { submitCurrentTask } from '../../../actions/taskActions';
import { TaskMessages } from '../TaskMessages/TaskMessages';
import { mediaBreakpoints } from '../../../common/responsive';
import { Timer } from './Timer';
import { get } from '@utils/lodash';

export namespace KBA {
  export interface Props {
    inputs: InputConfig[];
    opts: {
      task: {
        id: string;
        template: {
          inputs: { id: string; choices: { text: string; value: string }[] }[];
          customProps: {
            showBackToUserSelectButton?: boolean;
            hideMessage?: boolean;
            kbaStartedAt: string;
          };
        };
      };
    };
  }
}

const styles = StyleSheet.create({
  kbaWrapper: {
    position: 'relative',
    marginTop: 180,
    [mediaBreakpoints.mobile]: {
      marginTop: 36,
    },
  },
});

export const KBA: React.FC<KBA.Props> = ({ inputs, opts }) => {
  // const { task } = opts;
  const startTime = get(opts, 'task.template.customProps.kbaStartedAt');
  const messages = get(opts, 'task.template.messages');
  // const dispatch = useDispatch();

  const handleTimeout = async () => {
    // todo: submit a timeout after resolving issue with clock skewed submissions
    // const answerTimout = task.template.inputs.reduce((map, input) => {
    //   return {
    //     ...map,
    //     [input.id]: 'TIMEOUT',
    //   };
    // }, {});
    // const { task: nextTask } = await participantAPI.tasks.submitTask(task.id, answerTimout);
    // submitCurrentTask(nextTask)(dispatch);
  };

  return (
    <div className={css(styles.kbaWrapper)}>
      <TaskMessages messages={messages} />
      <TaskInputs inputs={inputs} />
      {!!startTime && <Timer startTime={startTime} handleTimeout={handleTimeout} />}
    </div>
  );
};
